module.exports = __webpack_public_path__ + "static/media/solution-ic-3.c474e98b.svg";